import {Pipe, PipeTransform} from '@angular/core';
@Pipe ({
   name : 'Priority'
})
export class Priority implements PipeTransform {
   transform(val: string): string {

    switch (val) {
        case 'LOWPRIORITY': return 'Low Priority';
        case 'MEDIUMPRIORITY': return 'Medium Priority';
        case 'FASTPRIORITY': return 'Fast Priority';
        case 'URGENTPRIORITY': return 'Urgent Same Day';
    }

    return val;
   }
}